function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSezione05Popup0303Img01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 362.31 241.87",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("polygon", {
    points: "280.55 241.58 230.58 241.52 239.21 178.33 265.33 149.95 304.87 162.47 325.68 185.08 339.23 241.51 280.55 241.58",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.55,241.87s.04,0,.05,0c.16-.03.26-.18.23-.34l-5.7-30.21c-.82-4.35-3.18-8.27-6.66-11.02l-2.97-2.35c-.13-.1-.31-.08-.41.05-.1.13-.08.31.05.41l2.97,2.35c3.36,2.67,5.66,6.46,6.45,10.67l5.7,30.21c.03.14.15.24.29.24",
    style: {
      fill: "#010101"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.23,241.8s.05,0,.07,0c.16-.04.25-.19.22-.35l-13.55-56.43s-.04-.09-.07-.13l-20.82-22.61s-.08-.06-.13-.08l-39.54-12.53c-.11-.03-.23,0-.3.08l-26.12,28.39s-.07.1-.07.16l-8.64,62c-.02.16.09.31.25.33.16.02.31-.09.33-.25l8.62-61.91,25.93-28.19,39.29,12.45,20.71,22.49,13.53,56.36c.03.13.15.22.28.22",
    style: {
      fill: "#010101"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.94,148.63l-3.71-85.13,6.04-1.88s1.71-3.38,4.47-3.38l20.11-.4c.95-.03,1.84.5,2.26,1.36l1.77,3.63-30.95,85.79Z",
    style: {
      fill: "#5b6faf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.43,61.6l-29.49,74.03,1.52-74.43s-17.19,3.6-25.91,7c-5.68,2.22-11.44,7.08-14.36,12.83l-19.44,41.47c-7.4,14.56-.34,31.6,15.63,35.07l.2.04c3.51.76,7.18.1,10.19-1.84l-2.16,33.53,93.05-2.39-20.03-121.74-9.21-3.57Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.77,68.76s.08,0,.12-.03c6.49-3.02,26.27-7.01,26.47-7.05.16-.03.26-.19.23-.34-.03-.16-.19-.26-.34-.23-.2.04-20.05,4.05-26.6,7.1-.15.07-.21.24-.14.39.05.11.15.17.26.17",
    style: {
      fill: "#010101"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.8,79.03c.05,0,.1-.01.15-.04l12.47-7.34c.14-.08.19-.26.1-.4-.08-.14-.26-.18-.4-.1l-12.21,7.18-4.23-8.12c-.07-.14-.25-.2-.39-.12-.14.07-.2.25-.12.39l4.37,8.39c.04.07.1.12.18.15.03,0,.05.01.08.01",
    style: {
      fill: "#010101"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.22,76.39c.08,0,.16-.03.22-.1l5.2-5.75c.11-.12.1-.3-.02-.41-.12-.11-.3-.1-.41.02l-4.85,5.35-1.33-4.83c-.04-.16-.2-.25-.36-.2-.16.04-.25.2-.2.36l1.47,5.34c.03.1.11.18.21.21.02,0,.04,0,.07,0",
    style: {
      fill: "#010101"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.75,81.6c.05,0,.11-.01.15-.04l10.82-6.72c.09-.05.14-.15.14-.26l-.27-9.42c0-.16-.13-.28-.29-.28h0c-.16,0-.29.14-.28.3l.27,9.26-10.68,6.63c-.14.08-.18.26-.09.4.06.09.15.14.25.14",
    style: {
      fill: "#010101"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.2,130.05c.09,0,.19-.05.24-.13l26.69-40.32c.06-.09.06-.2.02-.29l-5.44-10.67c-.07-.14-.25-.2-.39-.13-.14.07-.2.25-.13.39l5.37,10.52-26.6,40.18c-.09.13-.05.31.08.4.05.03.11.05.16.05",
    style: {
      fill: "#010101"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.57,79.03c.07,0,.15-.03.2-.08.11-.11.12-.3,0-.41l-7.17-7.28,3.5-7.07c.07-.14.01-.32-.13-.39-.14-.07-.32-.01-.39.13l-3.59,7.25c-.06.11-.03.25.05.33l7.32,7.43c.06.06.13.09.21.09",
    style: {
      fill: "#010101"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.46,130.05s.04,0,.06,0c.16-.03.26-.18.23-.34l-8.8-44.92,8.98-7.68c.12-.1.14-.29.03-.41-.1-.12-.29-.14-.41-.03l-9.1,7.79c-.08.07-.12.17-.1.28l8.83,45.09c.03.14.15.23.29.23",
    style: {
      fill: "#010101"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.09,189.75h.01l30.08-1.51c.14,0,.25-.11.27-.25l2.25-14.77,1.54,14.33c.02.15.14.26.29.26.34,0,34.59.03,54.51,1.14.16.02.3-.11.31-.28,0-.16-.11-.3-.27-.31-19.01-1.06-51.05-1.14-54.28-1.14l-1.75-16.3c-.02-.15-.14-.26-.28-.26-.16,0-.27.1-.29.25l-2.55,16.75-29.49,1.48,1.59-11.01c.02-.16-.09-.31-.25-.33-.16-.02-.31.09-.33.25l-1.64,11.36c-.01.09.01.17.07.24.06.06.13.1.22.1",
    style: {
      fill: "#010101"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.75,209.2c1.25-19.41,3.19-47.94,1.79-67.3-1.79-24.83-12.26-73.33-52.89-76.73-4.47-.37,3.91,41.1,3.36,45.12-3.57,26.19,12.11,67.69,12.11,67.69-.13,8.95-.04,17.9.26,26.84,5.64,3.58,12.15,5.81,18.81,6.37,5.58.47,11.25-.24,16.56-2",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.69,209.04c.15,0,.28-.12.29-.27l.23-3.6c1.24-19.02,2.93-45.08,1.61-63.28-.72-10.01-3.23-29.36-11.91-46.51-9.48-18.73-23.35-28.99-41.25-30.49-.16-.02-.3.11-.31.27-.01.16.11.3.27.31,17.68,1.48,31.4,11.63,40.78,30.17,8.63,17.07,11.13,36.33,11.85,46.29,1.31,18.17-.38,44.2-1.61,63.2l-.23,3.6c-.01.16.11.3.27.31,0,0,.01,0,.02,0",
    style: {
      fill: "#010101"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.37,203.72h.01c.16,0,.29-.14.28-.3-.31-9.14-.38-16.74-.26-25.43l.08-1.89c-.37-21.95-4.48-43.48-12.21-64.02-.06-.15-.22-.23-.37-.17-.15.06-.23.22-.17.38,7.7,20.47,11.79,41.94,12.17,63.81l-.08,1.88c-.12,8.7-.05,16.31.26,25.46,0,.16.13.28.29.28",
    style: {
      fill: "#010101"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.84,231.43c.78-8.12,1.52-16.25,1.9-23.69-5.31,1.76-10.98,2.47-16.56,2-6.66-.56-13.17-2.79-18.81-6.37.17,5.15.42,10.29.73,15.44.39,6.41,1.14,13.38,5.61,18,3.66,3.78,9.58,5.21,14.57,3.51,2.61,1.94,6.66,1.56,8.87-.83,2.16,1.74,5.88.86,7.03-1.66,1.16-2.52-.61-5.9-3.34-6.4",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.18,241.85c1.84,0,3.69-.67,4.99-1.97,1.07.75,2.52,1,3.93.66,1.51-.36,2.75-1.32,3.33-2.59.58-1.26.5-2.84-.22-4.21-.67-1.29-1.8-2.22-3.07-2.54.74-7.78,1.5-15.99,1.88-23.44,0-.1-.04-.19-.11-.25-.08-.06-.18-.07-.27-.04-5.3,1.76-10.99,2.44-16.45,1.98-6.57-.55-13.03-2.74-18.68-6.33-.09-.06-.21-.06-.3,0-.09.05-.15.15-.15.26.17,5.17.42,10.37.73,15.44.41,6.65,1.18,13.53,5.69,18.19,3.73,3.85,9.63,5.3,14.73,3.63,1.15.81,2.55,1.2,3.95,1.2M354.14,239.21c-.08,0-.16.03-.21.09-2.11,2.28-5.99,2.64-8.48.79-.08-.06-.18-.07-.27-.04-4.92,1.68-10.65.29-14.26-3.44-4.37-4.51-5.13-11.28-5.53-17.82-.3-4.89-.54-9.9-.71-14.88,5.61,3.46,11.99,5.58,18.47,6.12,5.4.45,11.02-.2,16.28-1.88-.39,7.41-1.14,15.54-1.88,23.25-.01.15.09.29.24.31,1.2.22,2.29,1.08,2.92,2.3.63,1.22.71,2.6.2,3.7-.51,1.1-1.6,1.95-2.94,2.26-1.34.32-2.7.05-3.65-.71-.05-.04-.12-.06-.18-.06",
    style: {
      fill: "#010101"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.9,239.47c.09,0,.18-.04.23-.12.1-.13.07-.31-.06-.41-3.89-2.85-5.95-7.96-5.12-12.7.03-.16-.08-.31-.24-.34-.16-.03-.31.08-.34.24-.87,4.96,1.28,10.29,5.35,13.27.05.04.11.06.17.06",
    style: {
      fill: "#010101"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.41,240.39c.08,0,.15-.03.21-.09.11-.12.11-.3,0-.41-3.39-3.24-5.2-7.97-4.86-12.64.01-.16-.11-.3-.27-.31-.16-.02-.3.11-.31.27-.36,4.84,1.52,9.75,5.03,13.11.06.05.13.08.2.08",
    style: {
      fill: "#010101"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.2,240.29c.07,0,.14-.03.2-.08.12-.11.12-.3,0-.41-3.46-3.61-5.22-8.74-4.71-13.71.02-.16-.1-.3-.26-.32-.16-.02-.3.1-.32.26-.53,5.14,1.29,10.44,4.87,14.17.06.06.13.09.21.09",
    style: {
      fill: "#010101"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.65,71.55l-.93-2.54s-5.2,2.35-11.79,6.3c-12.34,7.39-30.58,19.05-35.79,21.94-4.82-7.5-7.51-16.06-10.2-24.61-2.48,3.65-7.18,7.86-16.07,10.14-6.99,1.78-12.84.24-16.71-1.58,2.08,13.52,5.79,26.78,11.04,39.41,2.45,5.91,5.43,11.91,10.56,15.75,5.12,3.83,11.91,5.01,18.26,4.16,6.34-.86,12.3-3.59,17.75-6.95,13.74-8.47,24.61-21.33,31.14-36.04,3.27-7.36,2.74-25.97,2.74-25.97",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.3,104.64c.1,0,.2-.06.26-.15.08-.14.02-.32-.12-.39-1.86-1.01-3.8-3.23-5.75-6.6-.08-.14-.26-.19-.4-.11-.14.08-.19.26-.11.4,2.01,3.47,4.02,5.76,5.98,6.82.04.02.09.04.14.04",
    style: {
      fill: "#010101"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.15,97.54s.1-.01.14-.04c3.86-2.14,9.95-5.97,16.4-10.02,11.56-7.26,24.66-15.49,32.19-18.75.15-.06.22-.23.15-.38-.06-.15-.23-.22-.38-.15-7.57,3.28-20.69,11.52-32.27,18.79-6.44,4.05-12.53,7.87-16.38,10-.14.08-.19.26-.11.4.05.1.15.15.25.15",
    style: {
      fill: "#010101"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.27,51.27l4.16,19.09,17.2-11.95-3.59-15.06s-3.54-6.3-17.77,7.93",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.75,58.31s.05,0,.07,0c.16-.04.25-.2.21-.35l-3.71-14.68s-.02-.05-.03-.07c-.03-.05-.71-1.23-2.59-1.49-2.52-.35-7.28.99-15.64,9.35-.07.07-.1.17-.08.27l1.45,6.66c.03.16.19.26.35.22.16-.03.26-.19.22-.35l-1.42-6.5c8.1-8.07,12.64-9.39,15.01-9.08,1.46.19,2.06,1.01,2.17,1.17l3.69,14.64c.03.13.15.22.28.22",
    style: {
      fill: "#010101"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.9,18.39c-.52-5.41,1.68-11.07,5.86-14.54,4.19-3.47,10.28-4.58,15.35-2.59,5.07,1.98,8.82,7.07,9.02,12.5,4.58-1.04,9.68.58,12.8,4.09,3.13,3.51,4.16,8.75,2.6,13.18,1.1-.57,2.53.11,3.14,1.18.61,1.08.56,2.41.31,3.62-1.26,6.04-7.1,10.28-13.14,11.58-6.21,1.34-12.94.12-18.29-3.31-5.08-3.27-6.95-7.91-10.34-12.55-3.15-4.32-6.76-7.44-7.31-13.15",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.76,48.24c1.72,0,3.45-.18,5.15-.55,5.68-1.23,12.02-5.36,13.37-11.81.32-1.56.21-2.84-.34-3.82-.56-1-1.78-1.73-2.94-1.5,1.31-4.38.21-9.49-2.84-12.9-3.1-3.47-8.18-5.16-12.75-4.25-.34-5.34-4.08-10.41-9.19-12.42-5.06-1.98-11.35-.92-15.64,2.64-4.22,3.5-6.51,9.17-5.97,14.79.44,4.56,2.8,7.5,5.29,10.62.68.86,1.39,1.74,2.07,2.67.91,1.25,1.72,2.51,2.49,3.72,2.14,3.33,4.16,6.48,7.92,8.9,3.98,2.56,8.66,3.9,13.36,3.9M311.41,31.11c.8,0,1.62.55,2.01,1.24.48.85.57,2,.28,3.41-1.29,6.2-7.42,10.17-12.92,11.36-6.17,1.33-12.76.14-18.07-3.27-3.66-2.35-5.64-5.45-7.74-8.73-.78-1.22-1.6-2.49-2.52-3.75-.69-.94-1.4-1.83-2.09-2.69-2.44-3.05-4.75-5.93-5.17-10.31-.52-5.43,1.69-10.91,5.76-14.29,4.13-3.43,10.19-4.46,15.05-2.55,5.01,1.96,8.65,7,8.84,12.24,0,.09.04.17.11.22.07.05.16.07.24.05,4.45-1.01,9.48.6,12.52,4,3.04,3.41,4.06,8.58,2.54,12.88-.04.11,0,.24.08.32.09.08.22.09.32.04.24-.12.49-.18.74-.18M264.9,18.39h0,0Z",
    style: {
      fill: "#010101"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.95,21.39s-10.83,25.76-3.9,32.45c6.93,6.69,21.42-.26,25.16-7.92,0,0,5.11,1.76,7.83-4.93,2.93-7.21-3.28-7.55-7.83-4,0,0-6.12.37-4.07-3.83,2.05-4.19,2.68-8.12.55-10.57-3.31-3.81-17.74-1.21-17.74-1.21",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.32,56.82c1.03,0,2.01-.11,2.88-.26,6.23-1.1,12.69-5.51,15.16-10.31,1.09.25,5.5.85,7.94-5.16,1.54-3.78.43-5.35-.36-5.95-1.71-1.29-5-.63-7.84,1.56-.5.02-3.06.03-3.86-1.17-.36-.54-.31-1.3.15-2.24,2.35-4.81,2.52-8.57.51-10.89-3.38-3.89-17.41-1.41-18.01-1.3-.1.02-.18.08-.22.17-.44,1.06-10.83,26.02-3.84,32.77,2.22,2.15,4.99,2.78,7.47,2.78M295.21,45.62c-.11,0-.21.06-.26.16-2.31,4.73-8.69,9.12-14.85,10.2-2.85.5-6.88.5-9.85-2.36-6.44-6.22,3.05-29.88,3.91-31.98,1.56-.26,14.33-2.29,17.31,1.14,2.33,2.68.97,7.06-.59,10.25-.56,1.14-.6,2.09-.11,2.82,1.07,1.61,4.32,1.43,4.46,1.42.06,0,.12-.02.16-.06,2.62-2.04,5.71-2.74,7.21-1.61,1.14.86,1.2,2.73.17,5.27-2.58,6.36-7.26,4.83-7.46,4.76-.03-.01-.06-.02-.09-.02",
    style: {
      fill: "#010101"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.75,42.31c.07,0,.15-.03.2-.08,1.23-1.21,2.86-1.99,4.57-2.18.16-.02.27-.16.26-.32-.02-.16-.16-.28-.32-.26-1.85.21-3.59,1.05-4.92,2.35-.11.11-.12.3,0,.41.06.06.13.09.21.09",
    style: {
      fill: "#010101"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.65,65.47c.12,0,.23-.07.27-.19.06-.15-.02-.32-.17-.38l-9.15-3.52c-.15-.06-.32.02-.38.17-.06.15.02.32.17.38l9.15,3.52s.07.02.1.02",
    style: {
      fill: "#010101"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.73,13.27c-7.78,3.94-12.08,14.24-8.27,25.42,6.02,17.66-3.7,18.77-3.7,18.77,0,0,2.37,4.5,18.38,9.68,29.37,9.5,47.11-21.42,47.11-21.42,0,0-15.95,2.22-20.46-22.91-1.8-10.03-15.97-11.98-15.97-11.98,0,0-8.41-1.97-17.09,2.43",
    style: {
      fill: "#010101"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.54,241.52l4.16-82.28s-37.78,27.55-25.03-36.25c1.06-5.14,5.41-13.03,8.51-19.45,10.12-20.96,26.43-37.95,36.95-38.44l24.87-2.68s11.55.27,32.37,4.12c14.73,2.73,22.9,11.05,32.07,27.05,9.48,16.54,26.7,44.85,27.89,58.73,1.98,23.24-18.1,31.13-28.64,27.86-7.22-2.24-10.61-4.56-10.61-4.56l20.22,65.95c-8.47-.27-122.75-.06-122.75-.06",
    style: {
      fill: "#5b6faf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.72,147.69c.09,0,.17-.04.23-.11.1-.13.07-.31-.06-.41l-23.71-17.95c-.13-.1-.31-.07-.41.06-.1.13-.07.31.06.41l23.71,17.95c.05.04.11.06.18.06",
    style: {
      fill: "#010101"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "182.27 64.08 160.75 61.08 147.78 64.13 153.64 89.13 182.27 64.08",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.85,101.28c.07,0,.14-.03.19-.07l33.07-29.59c.12-.11.13-.29.02-.41-.11-.12-.29-.13-.41-.02l-32.7,29.25-6.87-33.57c-.03-.16-.19-.26-.34-.23-.16.03-.26.19-.23.34l6.97,34.07c.02.1.09.19.19.22.03,0,.06.01.09.01",
    style: {
      fill: "#010101"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.49,78.72c.06,0,.12-.02.17-.05.13-.1.16-.28.07-.41l-5-6.91c-.09-.12-.25-.16-.38-.08l-8.01,4.58c-.14.08-.19.26-.11.4.08.14.26.19.4.11l7.78-4.45,4.84,6.7c.06.08.15.12.24.12",
    style: {
      fill: "#010101"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.84,163.99s.08,0,.11-.02c1.8-.77,4.2-3.2,5.08-6.21.05-.15-.04-.32-.2-.36-.16-.04-.32.04-.36.2-.83,2.83-3.07,5.12-4.75,5.83-.15.06-.22.23-.15.38.05.11.15.18.27.18",
    style: {
      fill: "#010101"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.88,175.21c.12,0,.24-.08.28-.2.05-.15-.04-.32-.19-.36-5.58-1.75-17.76-9.28-19.13-10.13-.54-.33-1.18-.91-1.19-1.77-.02-1.92.61-6.1,1.81-8.63.07-.15,0-.32-.14-.39-.14-.07-.32,0-.39.14-1.24,2.6-1.89,6.91-1.86,8.89,0,.88.53,1.68,1.47,2.26,1.38.86,13.62,8.41,19.27,10.19.03,0,.06.01.09.01",
    style: {
      fill: "#010101"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "124.11 180.2 196.37 180.2 182.69 95.16 110.42 95.16 124.11 180.2",
    style: {
      fill: "#010101"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.8,131.11c0,.92-5.02,20.45-11.74,25.74l-10.97-9.46s-23.9-6.26-24.67-8.56c-.77-2.3,4.99-2.01,4.99-2.01,0,0-10.95-4.8-11.68-7.18-.72-2.38,3.36-2.53,6.68-1.14,0,0-8.74-3.05-8.75-6.36-.01-3.3,6.33-2.42,6.33-2.42,0,0-3.62-2.25-3.2-4.31.46-2.22,8.32-1.4,22.95,2.66,1.2.33,2.39-.49,2.23-1.72l-.38-3.03,28.19,17.78Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.25,140.44c.13,0,.25-.08.28-.21.04-.16-.05-.31-.2-.36l-10.19-2.8c-.15-.04-.32.05-.36.2-.04.16.05.32.2.36l10.19,2.8s.05.01.08.01",
    style: {
      fill: "#010101"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.07,133.65c.12,0,.24-.08.28-.2.05-.15-.03-.32-.19-.37l-13.59-4.49c-.15-.05-.32.03-.37.19-.05.15.03.32.19.37l13.59,4.49s.06.01.09.01",
    style: {
      fill: "#010101"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.05,125.73c.12,0,.24-.08.28-.2.05-.15-.03-.32-.19-.37l-16.88-5.48c-.15-.05-.32.03-.37.19-.05.15.03.32.19.37l16.88,5.48s.06.01.09.01",
    style: {
      fill: "#010101"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.51,36.88l1.39,26.6s3.54,8.05,13.54,4.82c4.79-1.55,7.28-4.64,7.28-4.64l-2.55-21.29-19.66-5.49Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.98,69.35c1.34,0,2.85-.23,4.54-.77,4.82-1.56,7.32-4.6,7.42-4.73.05-.06.07-.14.06-.22l-2.55-21.29c-.01-.12-.1-.21-.21-.25l-19.66-5.49c-.09-.03-.19,0-.26.05-.07.06-.11.15-.11.24l1.39,26.6s.01.07.02.1c.03.07,2.63,5.75,9.35,5.75M174.41,63.57c-.45.52-2.88,3.1-7.07,4.45-9.33,3.01-12.83-3.91-13.16-4.62l-1.36-26.14,19.08,5.33,2.52,20.97Z",
    style: {
      fill: "#010101"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.04,32.56s1.83,26.1,16,24.63c9.71-1.01,11.89-13.49,11.89-13.49,0,0,4.53-.78,4.78-5.8.25-5.02-7.43-7.08-8.63-.47,0,0-4.69-2.76-4.83-8.96,0,0-15.23-6.33-19.22,4.09",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.88,26.57v.58c-4.69,0-7.8,1.85-9.25,5.5.16,1.89,2.3,24.02,14.27,24.02.35,0,.71-.02,1.08-.06,3.81-.4,6.88-2.68,9.12-6.79,1.7-3.13,2.25-6.19,2.26-6.22.04-.24.23-.43.48-.47,0,0,1.02-.18,2.06-.92,1.39-.98,2.15-2.44,2.24-4.33.07-1.36-.52-2.28-1.02-2.81-.73-.77-1.79-1.23-2.82-1.23-1.85,0-3.21,1.38-3.64,3.69-.03.19-.16.35-.33.43-.08.04-.16.05-.24.05-.1,0-.2-.03-.3-.08-.2-.12-4.77-2.88-5.1-9.06-1.14-.43-4.93-1.73-8.81-1.73v-.58ZM153.88,26.57c4.79,0,9.38,1.9,9.38,1.9.14,6.2,4.83,8.96,4.83,8.96.54-2.95,2.37-4.17,4.21-4.17,2.28,0,4.56,1.87,4.42,4.65-.25,5.02-4.79,5.8-4.79,5.8,0,0-2.18,12.48-11.89,13.49-.39.04-.77.06-1.14.06-13.14,0-14.87-24.69-14.87-24.69,1.8-4.71,5.89-6,9.84-6",
    style: {
      fill: "#010101"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.13,41.77c.15,0,.27-.11.29-.26.18-1.76,1.16-3.4,2.63-4.39.13-.09.17-.27.08-.4-.09-.13-.27-.17-.4-.08-1.61,1.08-2.69,2.88-2.88,4.81-.02.16.1.3.26.32.01,0,.02,0,.03,0",
    style: {
      fill: "#010101"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.15,134.66c0,.85-3.51,7.55-7.67,15.2C4.63,166.12,0,184.34,0,202.86v38.66h111.71l-32.48-75.83.75-8.01-58.83-23.02Z",
    style: {
      fill: "#e4e9f6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.25,82.39c-4.24,6.24-13.52,7.38-19.83,10.89-1.71.95-3.47,1.81-5.27,2.57-1.82.77-3.68,1.47-5.58,1.93-1.86.44-3.84.6-5.71.11-.85-.22-1.67-.54-2.43-1.01-.33-.2-.62-.44-.9-.69-1.17.21-2.37.19-3.57-.02-3.74-.67-7.09-2.81-10.1-5.22-2.85-2.28-16.65-8.82-15.35-27.05.29-3.98,3.97-17.75,22.6-25.36,14.14-5.77,12.51-17.5,27.11-21.02,3.59-.87,10.05-.47,13.35,1.75,2.97,2,4.94,5.36,5.34,9.99.19,2.16.72,18.03,4.11,26.23,6.63,16.06-1.71,23.9-3.77,26.92",
    style: {
      fill: "#010101"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9,98.91l-13.25,41.58c-.65,2.03.29,4.23,2.2,5.17l40.78,20.05-29.73-66.8Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.32,144.76c.07,0,.13-.02.18-.07.12-.1.14-.29.04-.41-.71-.86-.94-2.02-.6-3.08l13.23-42.21c.05-.15-.04-.32-.19-.37-.15-.05-.32.04-.36.19l-13.23,42.2c-.39,1.26-.13,2.61.71,3.63.06.07.14.11.22.11",
    style: {
      fill: "#010101"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.82,80.76c-10.85-4.68-33.74-8.41-45.05-8.22,0,0-19.7-.81-29.58,2.47-25.27,9.3-25.51,36.67-18.35,51.7,1.34,2.82,2.97,6.19,4.82,9.81l16.01,25.81c6.02,8.49,10.74,11.01,16.26,11.67,12.19,1.47,27.96-15.06,32.61-20.31,0,0,7.01-23.87,5.36-31.34-2.57-11.65-1.87-8.31-1.87-8.31,0,0,10.9-25.72,19.79-33.27",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.05,167.4c.06,0,.12-.02.17-.06,3.43-2.51,6.98-5.62,10.56-9.24.11-.11.11-.3,0-.41-.11-.11-.3-.11-.41,0-3.56,3.6-7.09,6.69-10.49,9.18-.13.1-.16.28-.06.41.06.08.14.12.23.12",
    style: {
      fill: "#010101"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.55,157.61c.05,0,.11-.01.15-.04.14-.08.18-.26.09-.4l-12.9-20.8c-1.9-3.72-3.57-7.18-4.8-9.78-3.67-7.71-6.21-20.99-1.29-33.06,3.52-8.64,10.08-14.78,19.48-18.24,9.71-3.23,29.27-2.46,29.46-2.45,8.54-.15,28.28,1.96,44.96,8.2.15.06.32-.02.37-.17.06-.15-.02-.32-.17-.37-16.76-6.28-36.59-8.39-45.16-8.24-.18,0-19.85-.78-29.66,2.49-9.44,3.48-16.29,9.9-19.83,18.57-4.99,12.24-2.42,25.71,1.3,33.53,1.24,2.6,2.91,6.07,4.82,9.82l12.91,20.82c.06.09.15.14.25.14",
    style: {
      fill: "#010101"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.47,148.93c.06,0,.11-.02.16-.05l23.59-15.85c.13-.09.17-.27.08-.4-.09-.13-.27-.17-.4-.08l-23.59,15.85c-.13.09-.17.27-.08.4.06.08.15.13.24.13",
    style: {
      fill: "#010101"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.84,139.84s.09-.01.13-.03c.14-.07.2-.25.13-.39l-13.16-25.76c-.59-1.14-1.25-2.44-1.27-3.79-.02-1.2.63-2.63,1.89-2.93.16-.04.25-.19.22-.35-.04-.16-.19-.25-.35-.22-1.56.37-2.37,2.08-2.34,3.51.03,1.48.72,2.84,1.34,4.05l13.16,25.76c.05.1.15.16.26.16",
    style: {
      fill: "#010101"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.4,111.64s.05,0,.07,0c.16-.04.25-.2.21-.35-.02-.06-1.68-6.44-2.75-10.96-.19-.8-.41-1.71-.24-2.55.14-.74.7-1.52,1.49-1.59.16-.02.28-.16.26-.32-.02-.16-.16-.28-.32-.26-1.12.11-1.82,1.14-2,2.06-.19.96.04,1.94.25,2.8,1.07,4.53,2.74,10.91,2.75,10.98.03.13.15.22.28.22",
    style: {
      fill: "#010101"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "66.54 49.38 57.3 72.14 52.89 72.86 77.32 98.13 80.73 72.82 75.94 72.45 80.23 59.08 66.54 49.38",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.32,98.42s.06,0,.09-.01c.11-.04.18-.13.2-.24l3.41-25.31c.01-.08-.01-.16-.06-.22-.05-.06-.12-.1-.2-.11l-4.43-.34,4.17-13.02c.04-.12,0-.25-.11-.33l-13.69-9.7c-.07-.05-.17-.07-.25-.04-.09.02-.15.09-.19.17l-9.18,22.61-4.25.7c-.11.02-.19.09-.23.2s0,.22.07.29l24.44,25.27c.06.06.13.09.21.09M80.4,73.09l-3.29,24.41-23.63-24.44,3.86-.63c.1-.02.18-.08.22-.18l9.1-22.42,13.22,9.37-4.22,13.17c-.03.08-.01.18.04.25s.13.12.22.13l4.49.35Z",
    style: {
      fill: "#010101"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.57,73.82c.12,0,.24-.08.28-.2l.54-1.61c.05-.15-.03-.32-.18-.37-.15-.05-.32.03-.37.18l-.54,1.61c-.05.15.03.32.18.37.03.01.06.02.09.02",
    style: {
      fill: "#010101"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.5,44.87c-1.16-.54-2.54-.7-3.72-.2-1.82.77-2.73,2.99-2.46,4.95.26,1.96,1.46,3.68,2.85,5.09.91.93,1.96,1.79,3.22,2.08,1.26.29,2.77-.13,3.39-1.26,2.12,2.11,4.31,4.25,7.02,5.51,2.71,1.27,6.08,1.53,8.6-.08,2.11-1.34,3.31-3.74,3.93-6.16,1.02-4,.68-8.24-.33-12.24-1.01-4-2.67-7.8-4.33-11.57.02,1.35-1.17,2.55-2.51,2.75-1.34.2-2.72-.47-3.59-1.52.77,1.96.38,4.33-.98,5.95-1.36,1.61-3.63,2.41-5.7,1.99.63,1.04,1.21,2.15,1.38,3.36.26,1.84-.76,4.19-2.94,4.05-.74-.05-.99-.39-1.46-.9-.69-.75-1.45-1.37-2.38-1.8",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.29,62.37c1.57,0,3.05-.39,4.27-1.16,2.4-1.53,3.53-4.29,4.05-6.33.93-3.66.82-7.83-.33-12.38-1.02-4.03-2.71-7.89-4.35-11.62-.06-.13-.19-.2-.33-.17-.14.03-.23.15-.23.29.02,1.15-1.02,2.27-2.26,2.46-1.16.17-2.46-.38-3.32-1.41-.09-.11-.25-.14-.37-.07-.12.07-.18.22-.12.36.73,1.86.35,4.13-.93,5.65-1.28,1.53-3.46,2.29-5.41,1.89-.11-.02-.23.02-.3.12-.07.09-.07.22-.01.32.57.94,1.17,2.05,1.34,3.25.15,1.09-.19,2.3-.85,3.01-.48.52-1.08.76-1.79.71-.56-.04-.76-.26-1.16-.69l-.11-.12c-.78-.85-1.59-1.46-2.47-1.87-1.35-.62-2.79-.7-3.96-.2-2.08.88-2.9,3.31-2.64,5.25.23,1.74,1.22,3.51,2.93,5.26.81.83,1.93,1.82,3.36,2.16,1.18.28,2.7-.02,3.51-1.09,2.22,2.21,4.29,4.12,6.85,5.32,1.52.71,3.11,1.06,4.61,1.06M85.78,31.98c1.5,3.44,3.01,6.98,3.94,10.66,1.13,4.46,1.24,8.53.33,12.1-.5,1.94-1.56,4.56-3.8,5.98-2.64,1.68-6.03,1.13-8.32.06-2.57-1.2-4.66-3.18-6.94-5.46-.07-.06-.16-.1-.25-.08-.09.01-.17.07-.21.15-.58,1.06-2.02,1.37-3.07,1.12-1.29-.3-2.32-1.23-3.08-2-1.62-1.65-2.55-3.31-2.77-4.93-.23-1.68.5-3.88,2.29-4.64,1.02-.43,2.29-.36,3.49.2.82.38,1.55.93,2.29,1.73l.1.11c.42.46.75.83,1.55.88.88.06,1.66-.25,2.25-.89.79-.85,1.18-2.21,1-3.49-.15-1.08-.62-2.07-1.11-2.94,1.99.18,4.08-.65,5.36-2.18,1.18-1.4,1.66-3.38,1.33-5.19.91.68,2.03,1.01,3.06.86,1.18-.18,2.19-1.02,2.58-2.06M67.5,44.87h0,0Z",
    style: {
      fill: "#010101"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.47,52.87c.06,0,.13-.02.18-.06.13-.1.15-.28.05-.41-1.1-1.39-2.82-2.22-4.59-2.22h0c-.16,0-.29.13-.29.29,0,.16.13.29.29.29,1.57,0,3.16.77,4.14,2,.06.07.14.11.23.11",
    style: {
      fill: "#010101"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.53,153.69l-13.55-21.66s28.55-20.2,33.01-20.94l1.03,6.36s16.77-3.77,17.63-1.66c.46,1.12-3.7,3.84-3.7,3.84,0,0,1.36,2.11-1.75,4.93,0,0,2.19,2.53-2.04,4.79,0,0,.17,2.37-8.36,6.35-8.52,3.99-12.31,3.08-12.31,3.08l-9.95,14.91Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.53,153.98c.05,0,.11-.01.15-.04.14-.08.18-.26.09-.4l-13.41-21.42c1.5-1.05,10.13-7.09,17.87-12.52.13-.09.16-.27.07-.41-.09-.13-.27-.16-.41-.07-8.51,5.97-18.09,12.68-18.09,12.68-.13.09-.16.26-.08.39l13.55,21.66c.05.09.15.14.25.14",
    style: {
      fill: "#010101"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.71,124.12c4.92,0,9.77-1.25,14.09-3.65.14-.08.19-.26.11-.4-.08-.14-.26-.19-.4-.11-4.52,2.51-9.64,3.74-14.8,3.56-.15-.02-.3.12-.3.28,0,.16.12.3.28.3.34.01.68.02,1.02.02",
    style: {
      fill: "#010101"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.2,129.19s.04,0,.06,0c3.35-.67,6.55-1.88,9.5-3.62.14-.08.19-.26.1-.4-.08-.14-.26-.19-.4-.1-2.89,1.7-6.03,2.89-9.32,3.55-.16.03-.26.18-.23.34.03.14.15.23.28.23",
    style: {
      fill: "#010101"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.46,133.56s.05,0,.08-.01c3.08-.89,6.06-2.14,8.86-3.72.14-.08.19-.26.11-.4s-.26-.19-.4-.11c-2.75,1.56-5.69,2.8-8.73,3.67-.15.04-.24.21-.2.36.04.13.15.21.28.21",
    style: {
      fill: "#010101"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.72,76.24s3.7-14.66-9.47-21.48c-13.17-6.82-16.77-2.23-20.59.81-3.82,3.04-5.15,6.53-2.71,7.08,0,0-2.32,5.27,4.36,4.46,0,0,.46,4.12,6.29,1.84,0,0,1.92,3.33,8.3-1,1.3.39,4.93,1.62,9.52,4.75,1.29.88,4.29,3.55,4.29,3.55",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.84,76.39c.12,0,.24-.08.28-.2.05-.15,1.13-3.64.48-8.09-.59-4.11-2.85-9.81-10.21-13.6-12.28-6.33-16.37-2.92-19.97.08-.31.26-.62.52-.93.76-2.16,1.72-4.22,4.27-3.94,6.07.11.7.56,1.22,1.31,1.51.15.06.32-.02.38-.17.06-.15-.02-.32-.17-.38-.56-.22-.87-.56-.94-1.05-.21-1.35,1.33-3.62,3.73-5.53.31-.25.62-.51.94-.77,3.47-2.89,7.4-6.16,19.33,0,5.72,2.95,9.05,7.37,9.9,13.14.63,4.32-.45,7.82-.46,7.85-.05.15.04.32.19.37.03,0,.06.01.09.01",
    style: {
      fill: "#010101"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.46,68.85s.08,0,.11-.02c.15-.06.22-.23.16-.38-.17-.41-.09-.95.21-1.43.28-.45.68-.79,1.17-1.2,2.54-2.08,5.2-4.06,7.93-5.88.13-.09.17-.27.08-.4-.09-.13-.27-.17-.4-.08-2.74,1.83-5.42,3.82-7.97,5.91-.42.35-.95.78-1.3,1.34-.4.64-.49,1.38-.25,1.96.05.11.15.18.27.18",
    style: {
      fill: "#010101"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.3,67.21s.05,0,.07,0c.16-.04.25-.2.21-.35-.14-.58.04-1.29.49-1.89.43-.58,1.04-1.03,1.62-1.46l8.43-6.22c.13-.1.16-.28.06-.41-.1-.13-.28-.16-.41-.06l-8.43,6.22c-.62.46-1.26.93-1.75,1.58-.56.76-.78,1.62-.59,2.38.03.13.15.22.28.22",
    style: {
      fill: "#010101"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.94,63.01c.08,0,.16-.03.22-.1,3.17-3.59,6.89-6.61,11.05-8.98.14-.08.19-.26.11-.4-.08-.14-.26-.19-.4-.11-4.22,2.4-7.99,5.47-11.2,9.1-.11.12-.1.3.02.41.05.05.12.07.19.07",
    style: {
      fill: "#010101"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.59,64.42c.16,0,.29-.13.29-.28.01-.54.34-1.37.35-1.38.06-.15-.01-.32-.16-.38-.15-.06-.32.01-.38.16-.02.04-.37.93-.39,1.58,0,.16.12.29.28.3h0Z",
    style: {
      fill: "#010101"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSezione05Popup0303Img01);
export default __webpack_public_path__ + "static/media/sezione-05-popup-03-03-img-01.90e1051f1e1b0438743a2ce71dd96bd8.svg";
export { ForwardRef as ReactComponent };